import React, { useState, useEffect } from 'react';
import { adminApi } from '../../services/api';
import { toast } from 'sonner';
import { Building, Plus, MapPin, Users, UserCog, X, Gift, Handshake, Briefcase, Clock, CheckCircle2, Edit3, Save } from 'lucide-react';

export default function SuperadminBrands() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name: '', admin_name: '', admin_email: '', admin_password: '', venue_name: '', venue_address: '', plan: 'pro' });
  const [saving, setSaving] = useState(false);
  const [detail, setDetail] = useState(null);

  const fetchBrands = () => {
    adminApi.get('/superadmin/brands')
      .then(r => setBrands(r.data.brands || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchBrands(); }, []);

  const handleCreate = async () => {
    if (!form.name || !form.admin_email || !form.admin_password) { toast.error('Compila nome, email e password admin'); return; }
    setSaving(true);
    try {
      await adminApi.post('/superadmin/brands', form);
      toast.success(`Brand "${form.name}" creato!`);
      setShowCreate(false);
      setForm({ name: '', admin_name: '', admin_email: '', admin_password: '', venue_name: '', venue_address: '', plan: 'pro' });
      fetchBrands();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore');
    } finally {
      setSaving(false);
    }
  };

  const showDetail = async (brandId) => {
    try {
      const r = await adminApi.get(`/superadmin/brands/${brandId}`);
      setDetail(r.data);
    } catch { toast.error('Errore caricamento dettagli'); }
  };

  if (loading) return (
    <div className="flex items-center justify-center h-64">
      <div className="w-8 h-8 border-2 border-[#D44E20] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  return (
    <div className="p-6 md:p-8 lg:p-10" data-testid="superadmin-brands-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl md:text-3xl tracking-tight font-bold text-white">Brand</h1>
          <p className="text-[#64748B] text-sm mt-1">Gestisci i brand sulla piattaforma Lazo</p>
        </div>
        <button onClick={() => setShowCreate(!showCreate)} data-testid="sa-create-brand-btn"
          className="flex items-center gap-2 px-4 py-2.5 bg-[#D44E20] text-white rounded-xl text-sm font-medium hover:bg-[#B8421B] transition-colors">
          <Plus size={16} /> Nuovo Brand
        </button>
      </div>

      {/* Create form */}
      {showCreate && (
        <div className="bg-[#1E293B] rounded-2xl border border-[#334155] p-6 mb-6" data-testid="sa-create-brand-form">
          <h3 className="text-white font-semibold mb-4">Nuovo Brand</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-[#94A3B8] mb-1">Nome Brand *</label>
              <input data-testid="sa-brand-name" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Es: Pizzeria Da Mario"
                className="w-full px-3 py-2.5 rounded-xl bg-[#0F172A] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none" />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#94A3B8] mb-1">Piano</label>
              <select data-testid="sa-brand-plan" value={form.plan} onChange={e => setForm(f => ({ ...f, plan: e.target.value }))}
                className="w-full px-3 py-2.5 rounded-xl bg-[#0F172A] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none">
                <option value="free">Free</option>
                <option value="starter">Starter</option>
                <option value="pro">Pro</option>
                <option value="enterprise">Enterprise</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-[#94A3B8] mb-1">Nome Admin *</label>
              <input data-testid="sa-admin-name" value={form.admin_name} onChange={e => setForm(f => ({ ...f, admin_name: e.target.value }))} placeholder="Mario Rossi"
                className="w-full px-3 py-2.5 rounded-xl bg-[#0F172A] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none" />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#94A3B8] mb-1">Email Admin *</label>
              <input data-testid="sa-admin-email" value={form.admin_email} onChange={e => setForm(f => ({ ...f, admin_email: e.target.value }))} placeholder="admin@brand.it"
                className="w-full px-3 py-2.5 rounded-xl bg-[#0F172A] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none" />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#94A3B8] mb-1">Password Admin *</label>
              <input data-testid="sa-admin-password" type="password" value={form.admin_password} onChange={e => setForm(f => ({ ...f, admin_password: e.target.value }))}
                className="w-full px-3 py-2.5 rounded-xl bg-[#0F172A] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none" />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#94A3B8] mb-1">Nome primo PV</label>
              <input value={form.venue_name} onChange={e => setForm(f => ({ ...f, venue_name: e.target.value }))} placeholder="Es: Sede Principale"
                className="w-full px-3 py-2.5 rounded-xl bg-[#0F172A] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none" />
            </div>
          </div>
          <div className="flex gap-2 justify-end mt-4">
            <button onClick={() => setShowCreate(false)} className="px-4 py-2 rounded-xl text-sm text-[#64748B] hover:text-white transition-colors">Annulla</button>
            <button onClick={handleCreate} disabled={saving} data-testid="sa-submit-brand"
              className="px-5 py-2 rounded-xl text-sm font-medium bg-[#D44E20] text-white hover:bg-[#B8421B] transition-colors disabled:opacity-50">
              {saving ? 'Creazione...' : 'Crea Brand'}
            </button>
          </div>
        </div>
      )}

      {/* Brands grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {brands.map(b => (
          <div key={b.id}
            onClick={() => showDetail(b.id)}
            className="bg-[#1E293B] rounded-2xl border border-[#334155] p-5 hover:border-[#D44E20]/40 cursor-pointer transition-all hover:shadow-[0_0_30px_rgba(212,78,32,0.1)]"
            data-testid={`sa-brand-card-${b.id}`}>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-xl bg-[#334155] flex items-center justify-center flex-shrink-0 overflow-hidden">
                {b.logo_url ? <img src={b.logo_url} alt="" className="w-full h-full object-contain" /> : <span className="text-[#D44E20] font-bold text-lg">{b.name?.charAt(0)}</span>}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white font-semibold truncate">{b.name}</p>
                <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${b.plan === 'pro' ? 'bg-[#D44E20]/20 text-[#D44E20]' : 'bg-[#334155] text-[#94A3B8]'}`}>{b.plan}</span>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <div className="text-center p-2 rounded-xl bg-[#0F172A]">
                <p className="text-lg font-bold text-white tabular-nums">{b.venues_count}</p>
                <p className="text-[10px] text-[#64748B]">Venue</p>
              </div>
              <div className="text-center p-2 rounded-xl bg-[#0F172A]">
                <p className="text-lg font-bold text-white tabular-nums">{b.customers_count}</p>
                <p className="text-[10px] text-[#64748B]">Clienti</p>
              </div>
              <div className="text-center p-2 rounded-xl bg-[#0F172A]">
                <p className="text-lg font-bold text-white tabular-nums">{b.staff_count}</p>
                <p className="text-[10px] text-[#64748B]">Staff</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Detail modal */}
      {detail && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setDetail(null)}>
          <div className="bg-[#1E293B] rounded-2xl border border-[#334155] max-w-lg w-full p-6 max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-white">{detail.name}</h2>
              <button onClick={() => setDetail(null)} className="text-[#64748B] hover:text-white"><X size={18} /></button>
            </div>

            <h3 className="text-sm font-semibold text-[#94A3B8] uppercase mb-2 flex items-center gap-2"><MapPin size={14} /> Venues</h3>
            <div className="space-y-2 mb-4">
              {detail.venues?.map(v => (
                <div key={v.id} className="flex items-center gap-3 p-3 rounded-xl bg-[#0F172A]">
                  <MapPin size={14} className="text-[#D44E20]" />
                  <div className="flex-1">
                    <p className="text-sm text-white">{v.name}</p>
                    {v.address?.full && <p className="text-[10px] text-[#64748B]">{v.address.full}</p>}
                  </div>
                  <span className="text-xs text-[#64748B]">{v.customers_count} clienti</span>
                </div>
              ))}
            </div>

            <h3 className="text-sm font-semibold text-[#94A3B8] uppercase mb-2 flex items-center gap-2"><UserCog size={14} /> Admin</h3>
            <div className="space-y-2">
              {detail.admins?.map(a => (
                <div key={a.id} className="flex items-center gap-3 p-3 rounded-xl bg-[#0F172A]">
                  <div className="w-8 h-8 rounded-full bg-[#D44E20]/20 flex items-center justify-center">
                    <span className="text-[#D44E20] text-xs font-bold">{a.name?.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="text-sm text-white">{a.name}</p>
                    <p className="text-[10px] text-[#64748B]">{a.email} &middot; {a.role}</p>
                  </div>
                </div>
              ))}
            </div>

            <SubscriptionEditor brandId={detail.id} onSaved={fetchBrands} />
          </div>
        </div>
      )}
    </div>
  );
}


const BILLING_TYPES = [
  { key: 'paid', label: 'A pagamento', icon: CheckCircle2, color: 'text-emerald-400', bg: 'bg-emerald-500/10', desc: 'Cliente pagante regolare (incluso in MRR, riceve reminder)' },
  { key: 'trial', label: 'Trial custom', icon: Clock, color: 'text-amber-400', bg: 'bg-amber-500/10', desc: 'Prova gratuita con scadenza; riceve reminder ed è sospeso alla scadenza' },
  { key: 'complimentary', label: '🎁 Cortesia (gratis)', icon: Gift, color: 'text-pink-400', bg: 'bg-pink-500/10', desc: 'Regalo a founder/amici; non paga mai, nessun reminder' },
  { key: 'partner', label: '🤝 Partner', icon: Handshake, color: 'text-blue-400', bg: 'bg-blue-500/10', desc: 'Collaborazione esterna; escluso da MRR e reminder' },
  { key: 'internal', label: '🔧 Interno (Lazo)', icon: Briefcase, color: 'text-violet-400', bg: 'bg-violet-500/10', desc: 'Account interno o di test; non conta come cliente' },
];


function SubscriptionEditor({ brandId, onSaved }) {
  const [sub, setSub] = useState(null);
  const [packages, setPackages] = useState([]);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({});

  const load = React.useCallback(() => {
    Promise.all([
      adminApi.get(`/superadmin/brands/${brandId}/subscription`),
      adminApi.get('/superadmin/packages'),
    ]).then(([r1, r2]) => {
      setSub(r1.data);
      setPackages(r2.data.packages || []);
      setForm({
        package_id: r1.data.package_id || '',
        billing_type: r1.data.billing_type || 'paid',
        expires_at: r1.data.expires_at ? r1.data.expires_at.slice(0, 10) : '',
        internal_notes: r1.data.internal_notes || '',
      });
    }).catch(() => {});
  }, [brandId]);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put(`/superadmin/brands/${brandId}/subscription`, {
        package_id: form.package_id || null,
        billing_type: form.billing_type,
        expires_at: form.expires_at || null,
        internal_notes: form.internal_notes,
      });
      toast.success('Abbonamento aggiornato');
      setEditing(false);
      load();
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore');
    }
    setSaving(false);
  };

  if (!sub) return null;
  const currentType = BILLING_TYPES.find(t => t.key === (sub.billing_type || 'paid')) || BILLING_TYPES[0];
  const TypeIcon = currentType.icon;

  return (
    <div className="mt-6" data-testid="subscription-editor">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-[#94A3B8] uppercase flex items-center gap-2">
          <Briefcase size={14} /> Abbonamento
        </h3>
        {!editing && (
          <button
            onClick={() => setEditing(true)}
            data-testid="edit-subscription-btn"
            className="text-xs text-[#D44E20] hover:text-[#F59E0B] font-semibold flex items-center gap-1"
          >
            <Edit3 size={12} /> Modifica
          </button>
        )}
      </div>

      {!editing ? (
        <div className={`p-4 rounded-xl bg-[#0F172A] border border-[#334155]`} data-testid="subscription-summary">
          <div className="flex items-start gap-3">
            <div className={`w-9 h-9 rounded-lg ${currentType.bg} flex items-center justify-center flex-shrink-0`}>
              <TypeIcon size={16} className={currentType.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white font-semibold text-sm">{currentType.label}</p>
              <p className="text-[11px] text-[#64748B] mt-0.5">
                {sub.package_name ? `Piano: ${sub.package_name}` : 'Nessun pacchetto'}
                {sub.expires_at ? ` · Scade il ${new Date(sub.expires_at).toLocaleDateString('it-IT')}` : (sub.billing_type !== 'paid' && sub.billing_type !== 'trial' ? ' · Senza scadenza' : '')}
              </p>
              {sub.internal_notes && (
                <p className="text-[11px] text-[#94A3B8] italic mt-1.5">&ldquo;{sub.internal_notes}&rdquo;</p>
              )}
              {sub.granted_by && (
                <p className="text-[10px] text-[#475569] mt-1">Concesso da: {sub.granted_by}</p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="p-4 rounded-xl bg-[#0F172A] border border-[#334155] space-y-4" data-testid="subscription-editor-form">
          <div>
            <label className="block text-xs font-medium text-[#94A3B8] mb-2">Tipo abbonamento</label>
            <div className="space-y-2">
              {BILLING_TYPES.map(t => {
                const Icon = t.icon;
                const selected = form.billing_type === t.key;
                return (
                  <button
                    type="button"
                    key={t.key}
                    onClick={() => setForm(f => ({ ...f, billing_type: t.key }))}
                    data-testid={`billing-type-${t.key}`}
                    className={`w-full text-left p-3 rounded-lg border transition-colors ${selected ? 'border-[#D44E20] bg-[#D44E20]/10' : 'border-[#334155] hover:border-[#64748B]'}`}
                  >
                    <div className="flex items-start gap-2">
                      <div className={`w-7 h-7 rounded-lg ${t.bg} flex items-center justify-center flex-shrink-0`}>
                        <Icon size={13} className={t.color} />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-white font-semibold text-sm">{t.label}</p>
                        <p className="text-[10px] text-[#64748B] mt-0.5">{t.desc}</p>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-[#94A3B8] mb-1">Pacchetto</label>
            <select
              value={form.package_id || ''}
              onChange={e => setForm(f => ({ ...f, package_id: e.target.value }))}
              data-testid="package-select"
              className="w-full px-3 py-2 rounded-lg bg-[#1E293B] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none"
            >
              <option value="">— Nessuno —</option>
              {packages.map(p => (
                <option key={p.id} value={p.id}>{p.name} ({p.price_monthly}€/mese)</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-xs font-medium text-[#94A3B8] mb-1">
              Scadenza {['complimentary', 'partner', 'internal'].includes(form.billing_type) && <span className="text-[#64748B]">(lascia vuoto per "mai")</span>}
            </label>
            <input
              type="date"
              value={form.expires_at || ''}
              onChange={e => setForm(f => ({ ...f, expires_at: e.target.value }))}
              data-testid="expires-at-input"
              className="w-full px-3 py-2 rounded-lg bg-[#1E293B] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-[#94A3B8] mb-1">Note interne (perché è gratis / context)</label>
            <textarea
              value={form.internal_notes || ''}
              onChange={e => setForm(f => ({ ...f, internal_notes: e.target.value }))}
              rows={2}
              data-testid="internal-notes-input"
              placeholder="Es. Founding brand @makasam · Beta tester Luca · Partner founding team..."
              className="w-full px-3 py-2 rounded-lg bg-[#1E293B] border border-[#334155] text-white text-sm focus:border-[#D44E20] focus:outline-none resize-none"
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={() => { setEditing(false); load(); }}
              className="px-4 py-2 rounded-lg text-sm text-[#94A3B8] hover:text-white"
            >Annulla</button>
            <button
              onClick={save}
              disabled={saving}
              data-testid="save-subscription-btn"
              className="px-5 py-2 rounded-lg text-sm font-semibold bg-[#D44E20] text-white hover:bg-[#B8421B] disabled:opacity-50 flex items-center gap-2"
            >
              <Save size={13} /> {saving ? 'Salvataggio…' : 'Salva'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
